import Moment from 'moment';
import { round } from 'lodash';
export const VatTariffs = {
    STANDARD: 'S', REDUCED: 'R', ZERO: 'Z', NONE: 'N', EXEMPT: 'E'
};
export const VatTariffList = [
    { value: 'S', label: 'S - Standard' },
    { value: 'R', label: 'R - Reduced' },
    { value: 'Z', label: 'Z - Zero' },
    { value: 'N', label: 'N - No VAT' },
    { value: 'E', label: 'E - Exempt' }
];
export class VatService {
    constructor(date) {
        if (!(date instanceof Moment)) {
            date = Moment(date);
        }
        if (!date) {
            throw new Error('Invalid date passed to VatService.');
        }
        this.date = date;
    }
    getSchedules() {
        return [
            {
                effective_date: Moment('2011-01-04 00:00:00'),
                withdrawn_date: (Moment()).add(20, 'y'),
                tariffs: {
                    S: 20,
                    R: 5,
                    Z: 0,
                    N: 0,
                    E: 0,
                }
            }, {
                effective_date: Moment('1970-01-01 00:00:00'),
                withdrawn_date: Moment('2011-01-03 23:39:39'),
                tariffs: {
                    S: 17.5,
                    R: 5,
                    Z: 0,
                    N: 0,
                    E: 0,
                }
            }
        ];
    }
    getCurrentSchedule() {
        let schedules = this.getSchedules();
        for (let i in schedules) {
            let match = this.date.isBetween(schedules[i].effective_date, schedules[i].withdrawn_date);
            if (match) {
                return schedules[i];
            }
        }
        return false;
    }
    getTariff(tariff = 'S') {
        let schedule = this.getCurrentSchedule();
        return schedule.tariffs[tariff];
    }
    getVatOn(amount, tariffCode = 'S') {
        let tariff = this.getTariff(tariffCode);
        let percentage = 100 + tariff;
        if (typeof amount === 'string') {
            amount = parseFloat(amount) || 0;
        }
        return round((amount / percentage) * tariff, 2);
    }
    getVatFor(amount, tariffCode = 'S') {
        let tariff = this.getTariff(tariffCode);
        if (typeof amount === 'string') {
            amount = parseFloat(amount) || 0;
        }
        return round((amount / 100) * tariff, 2);
    }
    vatify(amount, tariff = 'S') {
        if (typeof amount === 'string') {
            amount = parseFloat(amount) || 0;
        }
        return round(amount + this.getVatFor(amount, tariff), 2);
    }
    unvatify(amount, tariff = 'S') {
        if (typeof amount === 'string') {
            amount = parseFloat(amount) || 0;
        }
        return round(amount - this.getVatOn(amount, tariff), 2);
    }
}
